<template src="./user-create.html">
</template>
<script>
  import Vue from 'vue'
  import { EventBus } from '@/router/bus'
  import Vuelidate from 'vuelidate'
  import { validationMixin } from '@/mixins/validation'
  import { required } from 'vuelidate/lib/validators'
  import Loader from '@/components/misc/Loader'

  Vue.use(Vuelidate)

  export default {
    name: 'user-create',
    components: {Loader},
    mixins: [validationMixin],
    data () {
      return {
        load: false,
        availableRoles: [],
        selectedRoles: [],
        availableClaims: [],
        selectedClaims: [],
        user: {
          login: '',
          name: '',
          email: ''
        }
      }
    },
    created: function (e) {
      // let roles = Vue.$config.user_roles

      // for (let i = 0; i < roles.length; i++) {
      //   let role = {}
      //   role.text = this.$t('userAdministration.' + roles[i])
      //   role.value = roles[i]
      //   this.availableRoles.push(role)
      // }

      this.retrieveRoles()
      // let claims = Vue.$config.user_claims

      // for (let i = 0; i < claims.length; i++) {
      //   let claim = {}
      //   claim.text = this.$t('userAdministration.' + claims[i])
      //   claim.value = claims[i]
      //   this.availableClaims.push(claim)
      // }
    },
    methods: {
      retrieveRoles () {
        this.load = true

        this.$http.get(Vue.$apiConfig.userPermissionHierarchyGet)
          .then(response => {
            let permissionHierarchy = response.data.payload
            this.availableRoles = this.getAvailableRoles(permissionHierarchy)
            let invalidRole = this.availableRoles.find(element => !element.valid_role)
            this.availableClaims = invalidRole ? invalidRole.claims : []
            this.selectedRoles.push(this.availableRoles[1].name)
            this.load = false
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      validateBeforeCreateUser () {
        this.logConsole(this.user)
        this.$v.$touch()
        if (this.$v.$invalid) {
          EventBus.$emit('alert', {
            variant: 'danger',
            message: this.$t('errors.someErrorsOccuredCheckListBelow'),
            errors: this.getValidationErrors('user')
          })
          return
        }
        this.createUser()
        this.logConsole('Submitted')
      },
      createUser () {
        this.load = true
        this.user.creationRoles = this.selectedRoles
        this.user.creationClaims = this.selectedClaims
        this.$http.post(Vue.$apiConfig.createLocalUserPost, this.user)
          .then(response => {
            this.logConsole(response)
            EventBus.$emit('alert', {
              variant: 'success',
              message: this.$t('userAdministration.userCreated'),
              errors: []
            })
            this.$refs.createUserForm.reset()
            this.load = false
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error)
            this.load = false
          })
      },
      getAvailableRoles (permissionHierarchy) {
        let roles = []
        let availableRoles = []
        if (Array.isArray(permissionHierarchy)) {
          // ES6 distinct
          availableRoles = [...new Set(permissionHierarchy.map(item => item.roleDescription))]
          availableRoles.forEach((availableRole) => {
            let isNull = !availableRole
            roles.push({
              name: isNull ? this.$t('userAdministration.ungroupedClaims') : availableRole,
              localized_name: isNull ? this.$t('userAdministration.ungroupedClaims') : this.$t('userAdministration.' + availableRole),
              description: isNull ? this.$t('userAdministration.Ungrouped_Description') : this.$t('userAdministration.' + availableRole + '_Description'),
              valid_role: !isNull,
              claims: []
            })
          })
          permissionHierarchy.forEach((item) => {
            let roleSearchCriteria = item.roleDescription === null ? this.$t('userAdministration.ungroupedClaims') : item.roleDescription
            var result = roles.filter((obj) => obj.name.localeCompare(roleSearchCriteria) === 0)
            if (result && result[0]) {
              result[0].claims.push({
                text: this.$t('userAdministration.' + item.claimDescription),
                value: item.claimDescription,
                id: item.claimId
              })
            }
          })
        }
        return roles
      }
    },
    validations: {
      user: {
        login: {
          required
        },
        name: {
          required
        },
        email: {
          required
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// UserCreate.vue?58f78da0